var panasonic_EUR7628010_DVD = {
    name: "EUR7628010_DVD",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,106,187,94,136],
        },
        {
            function: "KEY_REC",
            name: "KEY_REC",
            icon: "KEY_REC",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,239,245,104,128],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,109,118,250,32],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,218,251,232,128],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,119,110,170,136],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,183,118,170,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,255,245,162],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,175,235,90,32],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,173,255,183,237,90,32],
        },
    ]
}
export default panasonic_EUR7628010_DVD